import { useEffect } from "react";
import { CoreStoreInstance } from "../../Stores/CoreStore";

export function useFormLockConcurrency(formRef: string, formTypes: [number], lockNow: boolean = false) {
    useEffect(() => {
        CoreStoreInstance.FormLockConcurrencyHubStore.setFormsInfo(formRef, formTypes);

        if (lockNow) {
            const cb = () => {
                formTypes.forEach((formType) => {
                    CoreStoreInstance.FormLockConcurrencyHubStore.lockForm(formType);
                });
            };

            if (CoreStoreInstance.FormLockConcurrencyHubStore.getIsHubConnected) {
                cb();
            } else {
                CoreStoreInstance.FormLockConcurrencyHubStore.enqueueToConnectionQueue(cb);
            }
        }

        return () => CoreStoreInstance.FormLockConcurrencyHubStore.unlockAllForms();
    }, []);
}
